import React from "react";
import CommentManager from "../components/admin/CommentManager";
import GameUploader from "../components/admin/GameUploader";

function AdminDashboard() {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Admin Dashboard</h1>
      <hr />
      <GameUploader />
      <hr />
      <CommentManager />
    </div>
  );
}

export default AdminDashboard;
